import { useBooleanFlagValue } from "@openfeature/react-sdk";
export function useArgoCDIntegration(): boolean {
    return useBooleanFlagValue("argocd-integration-eap", false);
}
